import { combineReducers } from 'redux';
import wallet from './wallet';
import auth from './auth';
import languageReducer from './langauge';
import bankTransferReducer from './bankTransfer';

export default combineReducers({
  auth,
  wallet,
  languageReducer,
  bankTransferReducer,
});
